<template>
  <v-btn outlined small @click="handleGetAssetReport">
    <Loader
      v-if="isLoading"
      size="small"
      :color="this.loaderColor"
      text=""
    ></Loader>
    Asset Report (PDF)
  </v-btn>
</template>

<script>
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";
import { getAssetReport } from "@/services/reporting/reporting.service";

export default {
  name: "AssetReportButton",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    units: {
      type: String,
      required: true,
    },
    loaderColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  async mounted() {},
  methods: {
    async handleGetAssetReport() {
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.assets,
        EVENT_ACTIONS.clicked,
        "Asset Report " + this.id
      );
      let requestTimestamp = new Date().toISOString();
      this.isLoading = true;
      await getAssetReport(
        {
          assetId: this.id,
          monitorRadiusUnit: this.units,
        },
        requestTimestamp
      );
      this.isLoading = false;
    },
  },
};
</script>

<style scoped></style>
